import { ActionReducerMap } from '@ngrx/store';
import * as CrmState from '@zayan-erp/stores';

export interface AppState {
  crmReducer: CrmState.CrmState;
}

export const appReducers: ActionReducerMap<AppState> = {
  crmReducer: CrmState.crmReducer
};
